import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { CommonService as commonTripViewShuttleService } from 'src/app/trip-view/services/common.service';
import { ActivatedRoute, Params } from '@angular/router';
import { MapControlService } from '../../services/map-control.service';
import { DateUtils } from 'src/app/utils/days-utils';

@Component({
  selector: 'app-trip-replay',
  templateUrl: './trip-replay.component.html',
  styleUrls: ['./trip-replay.component.scss'],
})
export class TripReplayComponent implements OnInit, OnDestroy {
  response: any;
  tripId: String;
  tripDetails: any;
  loader: boolean = true;
  showSideBar: boolean = true;
  timezone = 'Asia/Manila';  adhoc_text: string;

  legUUID;
  IMEI;
  selectedRadioValue = 'MOBILE';
  sequenceId = 0;
  isCompletedTrip = true;
  driverFixedDevice = false;
  driverData: any;

  constructor(
    private commonService: CommonService,
    private commonTripViewShuttleService : commonTripViewShuttleService,
    private activatedRoute: ActivatedRoute,
    private mapControlService: MapControlService
  ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.commonService.buid = params['buid'];
      this.commonService.tripId = params['tripId'];
      this.commonService.source = params['source'] || '';
    });
    this.commonService.getTimeZone().subscribe((res) => {
      this.commonService.timeZone = res['timeZone'];
      this.timezone = res['timeZone'];
    })
  }

  ngOnDestroy(): void {
    this.mapControlService.resetVariables();
    this.commonService.driverFixedDevice=false;
  }

  ngOnInit(): void {
    console.log("interval",this.mapControlService.tripInterval)
    this.tripId = this.commonService.tripId;
    this.getTripData();
    this.getMetaData();
  }

  toggleSideBar() {
    this.showSideBar = !this.showSideBar;
  }

  getTripData(): void {
    this.loader = true;
    this.commonService.getTripDetails(this.commonService.tripId).subscribe(
      (res: any) => {
        if (res) {
          this.commonTripViewShuttleService.response = res
          this.adhoc_text = res?.tripDetails?.adhocConversionAudit?.fieldchange || '';
          
          const employeesByPlannedLocality = res.tripDetails.employees.reduce((acc: any, emp: any) => {
            const localityId = emp.plannedPickupLocation?.locationId;
            if (acc[localityId] === undefined) {
              acc[localityId] = [];
            }
            acc[localityId].push(emp);
            return acc;
          }, {});
          const employeesByActualLocalityId = res.tripDetails.employees.reduce((acc: any, emp: any) => {
            if (emp.actualPickupLocation != undefined) {
              const actualLocalityId = emp.actualPickupLocation.locationId;
              const plannedLocalityId = emp.plannedPickupLocation?.locationId;
              const localityId = emp.actualPickupLocation?.locationId;
    
              if (actualLocalityId !== plannedLocalityId) {
                if (acc[localityId] === undefined) {
                  acc[localityId] = [];
                }
                acc[localityId].push(emp);
              }
            }
            return acc;
    
          }, {});
          const allEmployees: any = res.tripDetails.employees.map((obj: { name: any, employeeId: any, gender: any, plannedPickupLocation: any, plannedPickupTime: any, plannedDropTime: any, distanceTravelled: any, phoneNumber: any, driverReportingTime: any, noShow: any, adhoc: any, actualPickupTime: any, actualDropTime: any, actualPickupLocation: any, shuttleEmpSignInType: any,signInSource:any }) =>
            (
              {
                name: obj?.name,
                Id: obj.employeeId,
                location: !!obj.plannedPickupLocation?.address ? obj.plannedPickupLocation?.address : obj.actualPickupLocation?.address,
                actualPickupLocation: obj.actualPickupLocation,
                plannedPickupLocation: obj.plannedPickupLocation,
                landmark: obj.plannedPickupLocation?.landmark,
                actualPickupTime: obj.actualPickupTime,
                signIn: obj.actualPickupTime ? DateUtils.formatTimeWithZone(obj.actualPickupTime, this.timezone, 'HH:mm') : "--",
                signOut: obj.actualDropTime ? DateUtils.formatTimeWithZone(obj.actualDropTime, this.timezone, 'HH:mm') : "--",
                reportTime: obj.driverReportingTime ? DateUtils.formatTimeWithZone(obj.driverReportingTime, this.timezone, 'HH:mm') : "--",                
                distance: parseFloat(obj.distanceTravelled).toFixed(1) + 'Km',
                gender: obj.gender,
                adhoc: obj.adhoc,
                noShow: obj.noShow,
                phone: obj.phoneNumber,
                empStatus: obj.shuttleEmpSignInType,
                plannedPickupTime: obj.plannedPickupTime ? DateUtils.formatTimeWithZone(obj.plannedPickupTime, this.timezone, 'HH:mm') : "--",
                geocord: !!obj.plannedPickupLocation ? obj.plannedPickupLocation['geocord'] : '',
                signInSource: obj.signInSource,
              }
            ));
          let shuttleStopsWithEmployees = res.tripDetails.shuttleStops?.map((stop: any, index: number) => {
  
            const employeesForStop = employeesByPlannedLocality[stop.nativeId] ?? [];
            const employeesByActualLocality = employeesByActualLocalityId[stop.nativeId] ?? [];
    
            // let employeeForPlannedStop=[];
            // allEmployees.forEach((emp)=>{
            //   if(emp.geocord===stop.geocord){
            //      employeeForPlannedStop.push(emp);
            //   }
            // })

            const simplifiedEmployees = employeesForStop.map((emp: any) => ({
              employeeId: emp.employeeId,
              stwId: emp.stwId,
              name: emp?.name,
              actualPickupTime: emp.actualPickupTime,
              actualDropTime: emp.actualDropTime,
              gender: emp.gender,
              localityId: emp.plannedPickupLocation.locationId,
              isPicked: (emp.actualPickupTime != 0 ? true : false),
              plannedPickupTime: emp.plannedPickupTime,
              plannedDropTime: emp.plannedDropTime,
              noShow: emp.noShow,
              plannedPickUpLocation: emp.plannedPickupLocation?.address,
              plannedDropLocation: emp.plannedDropLocation?.address,
              StopActualArrivalTime: stop.actualArrivalTime,
              signIn: emp.actualPickupTime === 0 ? '--' : DateUtils.formatTimeWithZone(emp.actualPickupTime, this.timezone, 'HH:mm'),
              signOut: emp.actualDropTime === 0 ? '--' : DateUtils.formatTimeWithZone(emp.actualDropTime, this.timezone, 'HH:mm'),
              
              adhoc: emp.adhoc,
              plannedLocalityId: emp.plannedPickupLocation.locationId,
              // actualLocalityId:emp.actualPickupLocation.locationId ?? null, // null check
              empStatus: emp.shuttleEmpSignInType,
              phoneNumber: emp.phoneNumber,
              geocord: emp.geocord,
              signInSource: emp.signInSource,
              signOffSource: emp.signOffSource,
            }));
    
            const numberOfEmployeestoBoard = simplifiedEmployees.filter((emp: any) => emp.adhoc === false).length;;
            const numberOfPickedEmployees = simplifiedEmployees.filter((emp: any) => emp.isPicked).length;
            const totalNumberOfNoShowEmployees = simplifiedEmployees.filter((emp: any) => emp.noShow).length;
            // const unPlannedEmployeesOnStopStatus = simplifiedEmployees.filter((emp: any) => emp.actualLocalityId === stop.localityId && (emp.empStatus === 'Adhoc' || emp.empStatus === 'unplanned'));
    
            let adhocEmployees = [];
            allEmployees.forEach(emp => {
    
              if (emp.adhoc === true && emp.actualPickupLocation.locationId === stop.nativeId) {
                adhocEmployees.push(emp);
              }
            })
    
            return {
              ...stop,
              index: index + 1,
              employees: simplifiedEmployees,
              numberOfEmployeestoBoard: numberOfEmployeestoBoard,
              numberOfEmployeesBoarded: numberOfPickedEmployees,
              totalNumberOfNoShowEmployees: totalNumberOfNoShowEmployees,formattedPlannedArrivalTime: stop.plannedArrivalTime === 0 ? '--' : DateUtils.formatTimeWithZone(stop.plannedArrivalTime, this.timezone, 'HH:mm'),
              formattedActualArrivalTime: stop.actualArrivalTime === 0 ? '--' : DateUtils.formatTimeWithZone(stop.actualArrivalTime, this.timezone, 'HH:mm'),              
              unPlannedEmployeesOnStop: employeesByActualLocality,
              adhocEmployees: adhocEmployees
            };
          });
          this.commonService.tripDetailsRes.next(res);
          this.commonService.newShuttleStops.next(shuttleStopsWithEmployees)
          this.commonService.employeeDetails$.next(allEmployees)
          this.commonService.response = res;
          this.tripDetails = res['tripDetails'];
          this.legUUID = this.tripDetails['tripUuid'];
          this.IMEI = this.getDeviceDetails().imei;
          this.getMilestones();
        }
      },
      (error) => {
        this.loader = true;
        console.log(error);
      }
    );
  }

  getMilestones() {
    this.loader = true;
    this.commonService
      .getTrackingSession(
        this.legUUID,
        (this.sequenceId = 0),
        this.IMEI,
        this.selectedRadioValue,
        this.isCompletedTrip,
        this.commonService.driverFixedDevice, 
        this.tripId
      )
      .subscribe(
        (res: any) => {
          if(res?.cabLocation==null)
          {
            res.cabLocation=res.milestones[0];
          }
          this.commonService.locationListRes.next(res.milestones);
          // this.commonService.locationListRes
          if(res.milestones[0]?.time - this.tripDetails.actualStartTime < 0 )
          {
            this.mapControlService.timer=res.milestones[0].time
          }
          else
          {
            this.mapControlService.timer=this.mapControlService.timer
          }
          // this.loader = false;
          this.getDeviceHealth();
        },
        (err) => console.log(err)
      );
  }

  getDeviceHealth() {
    // getting SOS location
    this.commonService
      .getDeviceHealth(
        this.tripDetails.actualStartTime,
        this.getDeviceDetails().deviceId,
        this.getDeviceDetails().imei
      )
      .subscribe((res) => {
        this.commonService.healthLogRes.next(res);
        // this.loader = false;
        this.getDriverActions();
      });
  }
  getDriverActions() { 
    this.commonService.getDriverActions(this.tripDetails.tripUuid,this.commonService.tripId).subscribe((res)=>
      {
        this.driverData = res;        
        this.getDriverOffData();
      })
  }
  getDriverOffData(){
    this.commonService.getDriverOffData(this.IMEI,this.tripDetails.vehicle.vehicleIdentification,this.tripDetails.actualStartTime,this.tripDetails.actualEndTime,this.commonService.buid).subscribe((res)=>
    {
      if( res?.['eventMap'] && Object.keys(res['eventMap'])?.length && res['eventMap']?.['DEVICE_INACTIVE']?.length) {
      this.commonService.driverOffData$.next(res);
      }
    // this.getMetaData()
    this.loader=false;
    })
  }
  getMetaData(){
    this.commonService.getMetaData().subscribe((res)=>
    {
      this.commonService.tripMetaData$.next(res);

    })
}

  getDeviceDetails(){

    let imei = '';
    let deviceId = ''
    try {
      imei = this.tripDetails.vehicle.deviceDTO.imei
      deviceId = this.tripDetails.vehicle.deviceDTO.deviceId
    }
    catch(e){
      imei = this.tripDetails.vehicle.externalDeviceImei ?? ''
      deviceId = '0'
    }

    return {
      imei,
      deviceId,
    }

  }

}
